import { QueryKey, UseQueryOptions, useQuery } from "@tanstack/react-query";
import { apiCall } from "api/axios";
import { API_BASE_URLS } from "api/axios/apiConfig";
import { IApiErrorData } from "api/axios/types";

interface FetchParams {
  apiRoute: string;
  module: keyof typeof API_BASE_URLS;
  useEncryption: boolean;
}

export const fetchData = async <R extends object>({
  apiRoute,
  module,
  useEncryption,
}: FetchParams): Promise<R> => {
  const result = await apiCall<R | IApiErrorData>({
    apiRoute,
    module,
    config: {
      method: "GET",
    },
    useEncryption,
  });

  if ("status" in result && result.status === "failed") {
    throw result; // Ensures that React Query handles it
  }
  return result as R;
};

export const useFetchData = <R extends object>(
  queryKey: QueryKey,
  params: FetchParams,
  options?: Omit<
    UseQueryOptions<R, unknown, R, QueryKey>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery<R, unknown, R, QueryKey>({
    queryKey,
    queryFn: () => fetchData<R>(params),
    ...options,
  });
};
